import {
  Component,
  inject,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { EConfigurationChannel } from '@web/dtos';
import { CloseOnOffClick } from '../../../../directives/close-on-off-click';
import { CmsTextProviderService } from '../../../../services/cms-text-provider.service';

@Component({
  selector: 'aw-configuration-channel-menu',
  imports: [CloseOnOffClick],
  templateUrl: './configuration-channel-menu.component.html',
})
export class ConfigurationChannelMenuComponent {
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
  protected readonly channel: typeof EConfigurationChannel =
    EConfigurationChannel;

  readonly channelSelected: OutputEmitterRef<EConfigurationChannel> =
    output<EConfigurationChannel>();
  readonly closed: OutputEmitterRef<void> = output<void>();
}
